module.exports = __webpack_public_path__ + "img/gift-1.3dc93fe7.jpg";